import React from "react";
import {
  Chip,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  pxToRem,
  Select,
} from "../../platform-style";
import { SelectChangeEvent } from "@mui/material";
import { CheckboxMenu } from "../CheckboxMenu/CheckboxMenu";

interface FilterMenuProps {
  filterItems: FilterMenuType[];
  selectedItems: string[];
  selectedFilterItemsInput: (filterMenus: string[]) => void;
  title: string;
  hideChips?: boolean;
  filterWidth?: number;
}

export interface FilterMenuType {
  area: string;
  count: string;
}

export const FilterMenu = ({
  filterItems,
  selectedItems,
  selectedFilterItemsInput,
  title,
  filterWidth,
  hideChips = false,
}: FilterMenuProps) => {
  const [selectedFilterItems, setSelectedFilterItems] = React.useState<string[]>([]);

  React.useEffect(() => {
    setSelectedFilterItems(selectedItems);
  }, [selectedItems]);
  const handleFilterMenuSelectionChange = (
    event: SelectChangeEvent<typeof selectedFilterItems>
  ) => {
    const {
      target: { value },
    } = event;

    setSelectedFilterItems(typeof value === "string" ? value.split(",") : value);
    selectedFilterItemsInput(typeof value === "string" ? value.split(",") : value);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: pxToRem(ITEM_HEIGHT * 8 + ITEM_PADDING_TOP),
        width: pxToRem(310),
        borderRadius: pxToRem(4),
      },
    },
  };

  return (
    <>
      <FormControl
        data-testid={"BusinessAreasForm"}
        sx={{ m: 1, width: pxToRem(filterWidth ?? 150) }}
      >
        <InputLabel id="filter-menu-checkbox-label"> {title}</InputLabel>
        <Select
          data-testid={"BusinessAreas"}
          labelId="filter-menu-checkbox-label"
          id="filter-menu-checkbox"
          multiple
          value={selectedFilterItems}
          onChange={handleFilterMenuSelectionChange}
          input={<OutlinedInput label={title} />}
          renderValue={(selected: string[]) => selected.join(", ")}
          MenuProps={MenuProps}
          sx={{
            backgroundColor: "background.paper",
            "#filter-menu-checkbox": {
              height: "1.4375em",
            },
          }}
        >
          {filterItems.map((filterItem: FilterMenuType) => (
            <MenuItem
              key={filterItem.area}
              value={filterItem.area}
              sx={{
                paddingLeft: pxToRem(8),
                whiteSpace: "normal",
              }}
            >
              <CheckboxMenu
                data-testid={"checkbox"}
                checked={selectedFilterItems.indexOf(filterItem.area) > -1}
              />
              <ListItemText primary={filterItem.area} />
              {!hideChips ? (
                <Chip
                  label={filterItem.count}
                  size="small"
                  variant="filled"
                  color={"primary"}
                  sx={{ borderRadius: "50", color: "header.contrastText", minWidth: "24px" }}
                />
              ) : (
                <></>
              )}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};
